import React from 'react';
import { bonuses } from '../data/bonuses';
export function Bonuses() {
  return <section className="bg-ice py-5 sm:py-7" data-id="element-17" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-18" data-mp="pjg4xyy2x3zv">
        <h2 className="text-center text-2xl leading-none text-navy sm:text-4xl" data-id="element-19" data-mp="avcv2egx185s">
          5 PREMIUM BONUSES <span className="text-aviation" data-id="element-20" data-mp="ftwi6i78wpzq">INCLUDED</span>
        </h2>

        <div className="mt-3 grid gap-2 md:grid-cols-2 md:gap-2.5" data-id="element-21" data-mp="fs3ffdzr6px0">
          {bonuses.map((bonus, i) => <article key={bonus.label} className={`rounded-xl border border-navy/10 bg-white p-3 shadow-sm sm:p-4 ${i === bonuses.length - 1 ? 'md:col-span-2' : ''}`} data-id="element-22" data-mp="5w0c44t60l8h" data-mpi={i}>
              <p className="w-fit rounded-md bg-gold px-2 py-0.5 font-display text-xs font-extrabold uppercase tracking-wide text-navy" data-id="element-23" data-mp="3t1rakhuu1q6a">
                {bonus.label}
              </p>
              <h3 className="mt-1 text-sm leading-tight text-navy sm:text-base" data-id="element-24" data-mp="1r9uwp1l7048c">{bonus.title}</h3>
              <p className="mt-1 text-sm leading-snug text-graphite" data-id="element-25" data-mp="3idwspw09nyr1">{bonus.body}</p>
            </article>)}
        </div>
      </div>
    </section>;
}